/**
 * SSR 旧链 FairListLegacyBiz 410 时，h3 createError 的 fatal 不会进入 __NUXT_DATA__，
 * 客户端 hydration 仍可能清错并跑 CSR middleware。此处把 payload error 标为 fatal。
 */
export default defineNuxtPlugin(nuxtApp => {
  const err = useError()
  if (!nuxtApp.isHydrating || !isFairListLegacyBizGone(err.value)) return

  const e = err.value as Record<string, unknown> | null | undefined
  if (e && !e.fatal) e.fatal = true
})

/** 旧链业务不可达（410；兼容历史 404 payload） */
function isFairListLegacyBizGone(err: { statusCode?: number; statusMessage?: string } | null | undefined): boolean {
  const code = err?.statusCode
  if (code !== 410 && code !== 404) return false
  return String(err?.statusMessage ?? '').startsWith('FairListLegacyBiz-')
}
